export enum PriceItemDataHooks {
  Item = 'price-item',
  Label = 'price-item-label',
  Price = 'price-item-description',
  PriceBeforeDiscount = 'price-before-discount',
  DiscountRuleName = 'discount-rule-name',
  CalculatedAtCheckout = 'calculated-at-checkout',
}
